import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app.routing';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [AppComponent],
    imports: [
        RouterModule,
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        OAuthModule.forRoot()
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
